import { createFileRoute } from '@tanstack/react-router';

import { SupplierProfilePage } from '@/features/supplier/profile-page';

export const Route = createFileRoute('/_app/supplier/$orgId/profile')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierProfilePage {...params} />;
}
